import request from '@/utils/request'

export function syncShop(data) {
    return new Promise((resolve, reject) => {
        request({
            url: '/sync.syncShop',
            method: 'post',
            data
        }).then(response => {
            const res = response.data
            resolve(res)
        }).catch(error => {
            reject(error)
        })
    })
}

export function getSyncStatus(data) {
    return new Promise((resolve, reject) => {
        request({
            url: '/sync.getSyncStatus',
            method: 'post',
            data
        }).then(response => {
            const res = response.data
            resolve(res)
        }).catch(error => {
            reject(error)
        })
    })
}
